import { environment } from '@env/environment'
import { ActionReducer, MetaReducer } from '@ngrx/store'
import { State } from './root.state'
import * as UserProfileActions from './user-profile-store/user-profile.actions'
import { storeFreeze } from 'ngrx-store-freeze'

export function clearState(reducer: ActionReducer<State>): ActionReducer<State> {
  return function (state, action) {
    if (action.type === UserProfileActions.logoutSucceeded().type) {
      state = undefined
    }

    return reducer(state, action)
  }
}

export const metaReducers: MetaReducer<State>[] = !environment.production ? [storeFreeze, clearState] : [clearState]
